<template>
  <ShipmentEventTimelineItem
    :shipment-event="event"
    class="event-popup"
    :class="{
      'has-geocode-error': isMissingCoords,
    }"
    :removable="false"
    disabled
    hide-menu
  >
    <template v-if="isMissingCoords" #extraRow>
      {{ t('maps.geocodeErrorParam', { param: t('events.events') }) }}
    </template>
  </ShipmentEventTimelineItem>
</template>

<script lang="ts" setup>
import { PropType, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { ShipmentEvent } from '@/model';

import ShipmentEventTimelineItem from '@/components/shipment/ShipmentEventTimelineItem.vue';

const props = defineProps({
  event: {
    type: Object as PropType<ShipmentEvent>,
    default: () => new ShipmentEvent(),
  },
  isMissingCoords: {
    type: Boolean,
    default: () => false,
  },
});
const { event, isMissingCoords } = toRefs(props);

const { t } = useI18n();
</script>

<style>
.event-popup {
  &.has-geocode-error {
    .body-row.extra {
      color: var(--danger-color);
    }
  }
}
</style>
